import React, {Component} from 'react';
import {ConnectedRouter} from 'connected-react-router/immutable';
import routes from '../../routes';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import 'semantic-ui-css/semantic.css';
import '../../style/css/customStyle.css';
import 'react-toastify/dist/ReactToastify.css';

export default class App extends Component {
    render() {
        const {history} = this.props;
        return (
            <div className="full-height">
                <div className="outerWrap">
                    <Header/>
                    <ConnectedRouter history={history}>{routes}</ConnectedRouter>
                    <div className="push"/>
                </div>
                <Footer/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/App/index.js